// extracted by mini-css-extract-plugin
export var mediumBtn = "index-module--mediumBtn--RJ3+M";
export var partner = "index-module--partner--QV7W0";
export var partnerBtn = "index-module--partnerBtn--xqe4q";
export var partnerContainer = "index-module--partnerContainer--gQDSy";
export var partnerInner = "index-module--partnerInner---ROXu";
export var partnerLink = "index-module--partnerLink--ZR010";